//
// Handles opening the report in a new window.
//
//  Josh Norris
//  2009
//
HEIJS.registerNamespace("HEIJS.Controls.ReportingServices");
HEIJS.Controls.ReportingServices.OpenReportInNewWindow = function ()
{
  if ($("div[id$=ReportViewer]").length == 1)
  {
    $find($("div[id$=ReportViewer]").attr("id")).exportReport("PDF");
  }
  else
  {
    alert('The report is not loaded');
  }
};

$(document).ready(
	function ()
	{
    // makes sure that the parameters box is always at the top of the column
	  if ($("div[id$=PromptAreaUpdatePanel]").length > 0)
	  {
	    $("div[id$=PromptAreaUpdatePanel]").parent().css("vertical-align", "top");
	  }
	});